// eslint-disable-next-line

import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

import {
  Grid,
  Checkbox,
  ListItemText,
  FormControlLabel,
  ButtonGroup,
  TextField,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TuneIcon from "@mui/icons-material/Tune";
import Radio from "@mui/material/Radio";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from "@mui/icons-material/Settings";

import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

import { makeStyles } from "@material-ui/core/styles";

import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import WwDatePicker from "../../Components/Modal/WwDatePicker";
import { grey } from "@mui/material/colors";
import Slide from "@mui/material/Slide";
import { findIndex, map } from "lodash";

import { joinByKeys } from "../../Js/Common";
import { getByMonth, currentMonth } from "../../Js/TimeAndDate";
import { getRolesBySiteUuid, getUsersByRoleId } from "../Users/Services";

const monthArr = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const SettingsModal = (props) => {
  // Redux state
  const containerRef = useRef();
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const classes = useStyles();

  const [allClassesList, setAllClassesList] = useState(null);

  useEffect(() => {
    setAllClassesList(props.classesList);
  }, [props.classesList]);

  const handleOpen = () => props.toggleVisibility(true);
  const handleClose = () => props.toggleVisibility(false);

  return (
    <div>
      <IconButton
        edge="end"
        au6ria-label="comments"
        sx={{ color: "primary.main" }}
        onClick={handleOpen}
      >
        <SettingsIcon
          sx={{
            color: "primary.main",
            fontSize: "1.7rem",
            "@media (min-width: 1636px)": {
              fontSize: "1.4rem",
            },
          }}
        />
      </IconButton>
      <Modal
        open={props.visible}
        onClose={handleClose}
        ref={containerRef}
        sx={{
          border: "0px !important",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Slide
          direction="up"
          in={props.visible}
          container={containerRef.current}
        >
          <Box className={classes.Modal}>
            <Grid container>
              {props.typesData &&
                props.typesData.map((type, index) => {
                  return (
                    <FormControl fullWidth sx={{ mx: 1, mb: 1 }} size="small">
                      <Grid container sx={{ gap: 1 }}>
                        <Grid item xs={5}>
                          <TextField
                            value={type.name}
                            size="small"
                            sx={{
                              backgroundColor: "#F5F5F5",
                            }}
                            onInput={(event) => {
                              props.typeStringChnage(
                                event.target.value,
                                type.value
                              );
                            }}
                          ></TextField>
                        </Grid>
                        <Grid item xs={6}>
                          <Select
                            value={type.classes}
                            displayEmpty
                            multiple
                            sx={{
                              backgroundColor: "#F5F5F5",
                              minWidth: "100%",
                              maxWidth: "100%",
                            }}
                            renderValue={(selected) => {
                              return map(selected, "value").join(", ");
                            }}
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            {allClassesList &&
                              allClassesList.map((val, index1) => {
                                return (
                                  <MenuItem
                                    value={val.id}
                                    key={`${index1}_classes_key`}
                                  >
                                    <Checkbox
                                      checked={
                                        type.classes
                                          ? type.classes.find(
                                              (o) => o.id == val.id
                                            )
                                          : []
                                      }
                                      onClick={() => {
                                        props.selectClassForSettings(
                                          val,
                                          type.value
                                        );
                                      }}
                                    />
                                    <ListItemText
                                      primary={val.value}
                                      onClick={() => {
                                        props.selectClassForSettings(
                                          val,
                                          type.value
                                        );
                                      }}
                                    />
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        </Grid>
                      </Grid>
                    </FormControl>
                  );
                })}
            </Grid>
            <Box sx={{ my: 3, mx: 4 }}>
              <Button
                variant="standard"
                fullWidth
                sx={{
                  color: "#FFFFFF",
                  fontSize: "1.2rem",
                  fontWeight: "700",
                  border: 1,
                  borderColor: "#FFFFFF",
                  borderRadius: 10,
                 
                }}
                onClick={props.saveSettingsRecord}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};
const useStyles = makeStyles({
  Modal: {
    width: 400,
    backgroundColor: "#DB8829",
    boxShadow: 24,
    color: "#FFFFFF",
    borderRadius: 30,
    padding: 20,
  },
  errorMessage: {
    backgroundColor: "red",
    color: "#FFFFFF",
    borderRadius: 30,
    padding: "10px 20px",
  },
});
export default SettingsModal;
